import url from 'Src/util/url'
import { isBp } from 'Src/util/tool'

// 特殊PATH无需拼aadvid表
const specialPath = {
  '/pages/select/account.html': true,
  '/pages/select/platform.html': true
}
// 首次访问url，自动拼接aadvid, 取消刷新
const queryObj = url.queryToJson(window.location.search) || {}
if (!queryObj.aadvid && !specialPath[window.location.pathname]) {
  window.history.replaceState({}, '', url.updateQueryWithAdvid(window.location.href))
}

// BP 页面域名迁移，加以适配
const addBpDomainUpdateQuery = function (strInfo, queryObj = {}) {
  if (isBp() && strInfo.startsWith('/pages/reporter/bp-report.html')) {
    strInfo = strInfo.replace('/pages/reporter/bp-report.html', '/site/analytic/bm-report.html')
  }
  return url.updateQueryWithAdvid(strInfo, queryObj)
}

// 组件内部全局注册方法
Vue.mixin({
  methods: {
    globalUpdateQuery: addBpDomainUpdateQuery,
    globalQuery: url.getQueryWithAdvid
  }
})
